import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import ApiServices from "../../services/apiservices";

function AdminNavbar({ sidebarOpen, setSidebarOpen }) {
  // State for the user profile dropdown
  const [profileOpen, setProfileOpen] = useState(false);

  const user = useSelector((state) => state.user.value);


  return (
    <div>
      {/* NAVBAR */}
      <nav className="bg-gray-900 text-white px-6 py-4 flex justify-between items-center relative shadow-md">
        
        {/* LEFT: Branding and Mobile Toggle */}
        <div className="flex items-center gap-4">
          <div className="lg:hidden">
            <button 
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="flex items-center justify-center"
            >
              {sidebarOpen ? (
                <FaTimes className="w-6 h-6" />
              ) : (
                <FaBars className="w-6 h-6" />
              )}
            </button>
          </div>
          <a href="/">
          <img src="/images/BEDCLogo.png" alt="BEDC Logo" className="h-16" />
          </a> 
          {/* <h1 className="text-xl font-bold">Admin Dashboard</h1> */}
        </div>

        {/* CENTER: Navigation Links */}
        <ul className="hidden lg:flex gap-6 text-sm font-medium">
          <li>
            <a href="/" className="hover:text-blue-400 transition-colors">Home</a>
          </li>
          <li>
            <a href="/blog" className="hover:text-blue-400 transition-colors">Blog</a>
          </li>
        </ul>

        <div className="relative">
          <div
            className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => setProfileOpen(!profileOpen)}
          >            <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold border-2 border-gray-700">
              {`${user.firstname.charAt(0)}${user.lastname.charAt(0)}`}
            </div>
              <span className="font-medium hidden sm:block">
                {`${user.firstname} ${user.lastname}`}
            </span>
          </div>

          {profileOpen && (
            <>
              <div 
                className="fixed inset-0 z-40" 
                onClick={() => setProfileOpen(false)}
              ></div>

              <div className="absolute right-0 mt-3 w-48 bg-white text-gray-800 shadow-xl rounded-lg p-2 border border-gray-200 z-50 animate-in fade-in zoom-in duration-150">
                <div className="px-3 py-2 border-b border-gray-100">
                    <p className="text-xs text-gray-500 uppercase font-semibold">Account</p>
                    <p className="font-medium truncate">{`${user.firstname} ${user.lastname}`}</p>
                </div>
                
                <a href="/admin/change-password">
                 <button 
                   className="w-full text-left px-3 py-2 mt-1 text-sm hover:bg-gray-100 rounded transition-colors"
                    onClick={() => console.log("Navigate to Change Password")}
                >
                  Change Password
                </button>

                </a>
                
                
                <button 
                    className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded transition-colors"
                    onClick={() => ApiServices.handleLogout()}
                >
                  Log Out
                </button>
              </div>
            </>
          )}
        </div>
      </nav>
    </div>
  );
}

export default AdminNavbar;